'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Modal(_ref) {
  var isOpen = _ref.isOpen,
      _ref$style = _ref.style,
      overlay = _ref$style.overlay,
      content = _ref$style.content,
      children = _ref.children;

  var overlayStyle = (0, _extends3.default)({}, Modal.defaultStyles.overlay, overlay);
  var contentStyle = (0, _extends3.default)({}, Modal.defaultStyles.content, content);
  return isOpen ? _react2.default.createElement(
    'div',
    { style: overlayStyle },
    _react2.default.createElement(
      'div',
      { style: contentStyle, tabIndex: '-1' },
      children
    )
  ) : null;
} // Modal

Modal.propTypes = {
  isOpen: _react.PropTypes.bool.isRequired,
  style: _react.PropTypes.object,
  children: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object])
  // #XXX: implement this while needed in the future
  // onRequestClose: React.PropTypes.func.isRequired
};

Modal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};

Modal.defaultStyles = {
  overlay: {
    zIndex: 1,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  content: {}
};

exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.js
// module id = 578
// module chunks = 0